import { createSlice } from '@reduxjs/toolkit'
import { UpdateStateWallet } from '../services/last-state-service';
import { BrowserWallet } from '@meshsdk/core';
import { Blockfrost, Lucid } from 'lucid-cardano';

export const walletSlice = createSlice({
  name: 'wallet',
  initialState: {
    value: null,
    address: null,
  },
  reducers: {
    setWallet: (state, action) => {
        state.value = action.payload;
        UpdateStateWallet({walletName: state.value});
    },

    setWalletAddress: (state, action) => {
      state.address = action.payload;
    },
  },
})

export const setWalletAsync = (walletData, config) => async (dispatch) => {
  dispatch(walletSlice.actions.setWallet(walletData));
  try {
    if (walletData) {
      const result = await connectLucidWallet(walletData, config);
      if (result) 
        dispatch(walletSlice.actions.setWalletAddress(result))
    }

  } catch (error) {
    console.error('Async operation failed:', error);
  }
};

export const { setWallet, setWalletAddress } = walletSlice.actions

export const selectWallet = (state) => state.wallet.value
export const selectWalletAddress = (state) => state.wallet.address

export default walletSlice.reducer


export async function connectLucidWallet(walletName, config) {

  const wallet = await BrowserWallet.enable(walletName);

  const lucid = await Lucid.new(
    new Blockfrost(config.blockfrostUrl, config.blockfrostKey),
    config.blockfrostNetwork
  );

  lucid.selectWallet(wallet._walletInstance);
  window.lucid = lucid;
  const address = await window.lucid.wallet.address();
  return address;
}